import { useContext } from "react";
import AuthProvider, { AuthContext } from "./AuthProvider";

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
